module.exports = __webpack_public_path__ + "img/product2_FF6B00_range.57e3718f.png";